import React from 'react';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Loading as LoadingSpinner } from '../../../../../CommonComponents/OPL/Loading/Loading';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  onClose: () => void;
}

export const Loading = ({ onClose }: Props) => {
  return (
    <Modal isOpen size="xl" aria={{ labelledby: 'Generate Report' }}>
      <ModalHeader as="h2" id="modal-header">
        Generate Report
      </ModalHeader>

      <ModalCloseButton onClick={onClose} />

      <ModalBody
        css={{
          minHeight: '800px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
        }}
      >
        <LoadingSpinner text="Please wait while we generate your PDF preview. This may take a moment..." />
      </ModalBody>

      <ModalFooter>
        <Box flex={1}>
          <Button variant="subtleInactive" onClick={onClose}>
            Cancel
          </Button>
        </Box>

        <Button ml="8" onClick={() => {}} isLoading>
          Download Draft Report
        </Button>

        <Button ml="8" onClick={() => {}} isLoading>
          Save & Download Final Report
        </Button>
      </ModalFooter>
    </Modal>
  );
};
